import React from 'react';
import { ISubmission } from '../../../types/global/helper';
import { ContestSubmissionModal } from './ContestSubmissionModal';

export interface IPreviewSubmission {
    onClose?: () => void;
    open: boolean;
    submission?: ISubmission;
    onRescindSubmisison?: (submission: ISubmission) => void;
}
const PreviewSubmission: React.FC<IPreviewSubmission> = props => {
    const { open, onClose, submission, onRescindSubmisison } = props;

    if (!submission) {
        return null;
    }

    return (
        <ContestSubmissionModal
            open={open}
            onClose={onClose || (() => {})}
            submission={submission}
            onRescindSubmission={onRescindSubmisison}
        />
    );
};

export { PreviewSubmission };
